import { getFetchWrapper } from "../core/src/getFetchWrapper.js";
import "@tanstack/react-query";
import { paymentMethodsCacheKey } from "../payment-methods/src/cacheKeys.js";
import "syf-js-utilities";
import { getItem } from "../alternate-payment-methods/src/api/requestStorage.js";
import { alternatePaymentMethodsCacheKey } from "../alternate-payment-methods/src/cacheKeys.js";
import { autopayStatusUrl } from "../endpoints.js";
const generatePaymentCardInfo = (paymentMethodId) => {
  const alternatePaymentMethod = getItem(paymentMethodId);
  if (!alternatePaymentMethod) {
    return {
      id: paymentMethodId
    };
  }
  const { paymentCardInfo } = alternatePaymentMethod;
  if (!paymentCardInfo) {
    throw new Error(
      `No payment card info set for payment method ${paymentMethodId}`
    );
  }
  return paymentCardInfo;
};
const generateACHPaymentMethodInfo = (paymentMethodId) => {
  const alternatePaymentMethod = getItem(paymentMethodId);
  if (!alternatePaymentMethod) {
    return {
      id: paymentMethodId
    };
  }
  const { paymentMethod } = alternatePaymentMethod;
  if (!paymentMethod) {
    throw new Error(
      `No payment method info set for payment method ${paymentMethodId}`
    );
  }
  return paymentMethod;
};
const pureMutationFnFactory = (config, keyProps, headers = {}) => {
  const fetchWrapper = getFetchWrapper(config);
  return (autopayStatusMutationVariables) => {
    if (autopayStatusMutationVariables.enrollment) {
      const { paymentAmount, paymentMethod, paymentOption } = autopayStatusMutationVariables;
      return fetchWrapper(autopayStatusUrl, {
        method: "PUT",
        headers,
        body: JSON.stringify({
          accountIdType: keyProps.accountIdType,
          "cipher.accountId": keyProps.accountId,
          enrollment: true,
          paymentAmount,
          paymentMethod,
          paymentOption
        })
      });
    }
    return fetchWrapper(autopayStatusUrl, {
      method: "PUT",
      body: JSON.stringify({
        accountIdType: keyProps.accountIdType,
        "cipher.accountId": keyProps.accountId,
        enrollment: false
      })
    });
  };
};
const mutationFnFactory = (config, keyProps, headers, queryClient) => {
  const fetchWrapper = getFetchWrapper(config);
  if (!queryClient) {
    return pureMutationFnFactory(config, keyProps, headers);
  }
  return (autopayStatusMutationVariables) => {
    var _a, _b;
    const alternatePaymentMethods = queryClient.getQueryData(
      alternatePaymentMethodsCacheKey(
        keyProps
      )
    );
    const registeredPaymentMethods = queryClient.getQueryData(
      paymentMethodsCacheKey(keyProps)
    );
    if (autopayStatusMutationVariables.enrollment) {
      const findFn = (paymentMethod2) => {
        var _a2;
        return paymentMethod2.id === ((_a2 = autopayStatusMutationVariables.paymentMethod) == null ? void 0 : _a2.id);
      };
      const { paymentAmount, paymentOption } = autopayStatusMutationVariables;
      const alternatePaymentMethod = (_a = alternatePaymentMethods == null ? void 0 : alternatePaymentMethods.paymentMethods) == null ? void 0 : _a.find(findFn);
      const registeredPaymentMethod = (_b = registeredPaymentMethods == null ? void 0 : registeredPaymentMethods.paymentMethods) == null ? void 0 : _b.find(findFn);
      const paymentMethod = alternatePaymentMethod || registeredPaymentMethod;
      if (!paymentMethod) {
        throw new Error("Payment method not found");
      }
      const paymentMedium = paymentMethod.paymentMedium || "E_CHECK";
      switch (paymentMedium) {
        case "E_CHECK": {
          const paymentMethodInfo = generateACHPaymentMethodInfo(
            paymentMethod.id
          );
          return fetchWrapper(autopayStatusUrl, {
            method: "PUT",
            headers,
            body: JSON.stringify({
              accountIdType: keyProps.accountIdType,
              "cipher.accountId": keyProps.accountId,
              enrollment: true,
              paymentAmount,
              paymentMedium,
              paymentMethod: paymentMethodInfo,
              paymentOption
            })
          });
        }
        case "CREDIT_CARD":
        case "PINLESS_DEBIT_CARD": {
          const paymentCardInfo = generatePaymentCardInfo(paymentMethod.id);
          return fetchWrapper(autopayStatusUrl, {
            method: "PUT",
            headers,
            body: JSON.stringify({
              accountIdType: keyProps.accountIdType,
              "cipher.accountId": keyProps.accountId,
              enrollment: true,
              paymentAmount,
              paymentMedium,
              paymentCardInfo,
              paymentOption
            })
          });
        }
        default:
          throw new Error(
            `Invalid or undefined payment medium: ${paymentMedium}`
          );
      }
    }
    return fetchWrapper(autopayStatusUrl, {
      method: "PUT",
      body: JSON.stringify({
        accountIdType: keyProps.accountIdType,
        "cipher.accountId": keyProps.accountId,
        enrollment: false
      })
    });
  };
};
export {
  mutationFnFactory as default
};
//# sourceMappingURL=mutation.js.map
